import { cn, platformProps } from "../../lib";
import { Box } from "../../primitives";
import { Image } from "../../primitives/image";
import { useCardContext } from "./card-context";
import type { CardImageProps } from "./types";

export const CardImage = ({
  src,
  alt,
  width = 64,
  height = 64,
  contentFit = "cover",
  className,
  testID,
}: CardImageProps) => {
  const { direction } = useCardContext();
  return (
    <Box
      className={cn(
        // `flex`: on web an inline image would leave a line's descent under
        // it, so the clip ran 4px past the image and its bottom corners showed
        // square
        "rounded-radius-md flex shrink-0 overflow-hidden",
        // A column stretches its children across, so the clip would be wider
        // than the image and leave its right corners square
        direction === "col" && "self-start",
        className,
      )}
      {...platformProps({ testID, slot: "card-image" })}
    >
      <Image src={src} alt={alt} width={width} height={height} contentFit={contentFit} />
    </Box>
  );
};

CardImage.displayName = "Card.Image";
